import React from "react";
import { useNavigate } from "react-router-dom";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import FilePickerDialog from "@/modules/hub/features/FileManagement/components/FilePickerDialog/FilePickerDialog";

/**
 * FileManagementPage
 *
 * A wrapper component that renders FilePickerDialog in manager mode
 * for direct URL access (/admin/file-manager). This ensures backward
 * compatibility for users who have bookmarked the file manager or
 * access it directly via URL.
 */
export default function FileManagementPage() {
  const navigate = useNavigate();

  const handleClose = () => {
    // Navigate back to the admin section when closing
    navigate("/admin");
  };

  return (
    <MainPageWrapper>
      <div className="h-screen">
        <FilePickerDialog
          mode="manager"
          isOpen={true}
          onClose={handleClose}
          onSelect={() => {}} // No-op in manager mode
          multiSelect={true} // Allow multi-select for bulk operations
        />
      </div>
    </MainPageWrapper>
  );
}